<template>
    <div>
        <div class="title">
            <div id="title">
                <div class="title_holder">
                    Justin Thouless
                </div>
            </div>
            <div class="title-line line" />
            <div class="subtext">
                Graphic Design & Illustration
            </div>
        </div>
        
        <div class="background">
            <Parallax>
                <img src="/images/banner_site.jpg">
            </Parallax>
        </div>
    </div>
</template>

<script>
    export default {
         mounted() {
            const fittext = require("../assets/js/fittext.js")
            fitText(document.getElementById('title'))
        },
    }
</script>

<style lang="scss" scoped>

</style>